import * as React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement="top-end"
    arrow={false}
  />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 300,
    backgroundColor: "#fff !important",
    boxShadow: "2px 4px #0004",
    border: "solid 1px #0003",
    overflow: "none",
    marginBottom: 10,
  },
});
export default CustomWidthTooltip;
